import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from 'ui';
import { injectIntl } from 'react-intl';
import duplicateImage from '../../../assets/images/duplicate_image.png';
import MultipleSelectionCard from './multiple-selection-card';

const Title = styled.div`
  text-align: center;
  margin-top: 50px;
  font-size: 48px;
  color: ${p => p.theme.colors.theme};
  font-weight: 400;
`;

const Container = styled.div`
  width: 36%;
`;

const Text = styled.div`
  font-size: 16px;
  white-space: pre-wrap;
`;

const SubText = styled.div`
  margin: 30px 0;
  font-size: 12px;
`;

const Image = styled.div`
  text-align: center;
  margin: 50px 0;
`;

const Tiles = styled(Flex)`
  margin-top: 20px;
  width: 250%;
  margin-left: -75%;
`;

const MultipleSelectionPage = ({
  type,
  value,
  referenceId = '',
  activeServiceCenterId,
  setActiveServiceCenter,
  data = [],
  intl,
  contextId,
}) =>
  <Flex aic jcc ffcn>
    <Container>
      <Title>{intl.formatMessage({ id: 'direct.MULTIPLE_TITLE' })}</Title>
      <Image><img src={duplicateImage} /></Image>
      <Text>
        {/* This is legacy in react-intl 4,
              we'll need to adjust this in next dependency bump */}
        {intl.formatMessage(
          { id: 'direct.MULTIPLE_DESCRIPTION' },
          {
            searchedKeyAndValue: value,
            object: type,
            b: msg => <b>{msg}</b>,
          },
        )}
      </Text>
      <Tiles aic jcc ffrw>
        {data?.map(d => <MultipleSelectionCard
          key={d}
          type={type}
          data={d}
          activeServiceCenterId={activeServiceCenterId}
          setActiveServiceCenter={setActiveServiceCenter}
          contextId={contextId}
        />)}
      </Tiles>
      <Text>
        {intl.formatMessage({ id: 'direct.MULTIPLE_INSTRUCTION' })}
      </Text>
      <SubText>{intl.formatMessage({ id: 'direct.NOT_FOUND_ID_EVENT' }, { referenceId })}</SubText>
    </Container>
  </Flex>;
MultipleSelectionPage.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  referenceId: PropTypes.string,
  data: PropTypes.array,
  intl: PropTypes.object,
  activeServiceCenterId: PropTypes.string,
  setActiveServiceCenter: PropTypes.func,
  contextId: PropTypes.string,
};

export default injectIntl(MultipleSelectionPage);
